import {
  DialogActions as MuiDialogActions,
  DialogActionsProps as MuiDialogActionsProps,
} from '@mui/material';

import { usePhoneLayout } from '../../hooks/usePhoneLayout';

type DialogActionsProps = Omit<MuiDialogActionsProps, 'sx'> & {
  compact?: boolean;
  sx?: object;
};

export function DialogActions({
  children,
  compact = false,
  sx,
  ...props
}: DialogActionsProps) {
  const phone = usePhoneLayout();
  return (
    <MuiDialogActions
      {...props}
      sx={{
        position: 'sticky',
        bottom: 0,
        flexShrink: 0,
        mt: 'auto',
        width: '100%',
        boxSizing: 'border-box',
        bgcolor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
        zIndex: 2,
        px: phone ? 2 : 3,
        py: 2,
        gap: 1,
        '& > :not(style) ~ :not(style)': { marginLeft: 0 },
        flexDirection: compact || !phone ? 'row' : 'column-reverse',
        flexWrap: compact || phone ? 'nowrap' : 'wrap',
        '& > *': { width: compact || !phone ? 'auto' : '100%' },
        ...sx,
      }}
    >
      {children}
    </MuiDialogActions>
  );
}
